import React from "react";

import { Card, LazyLoadImage } from "components";

export const FunkyCard = ({ image, content, foot, fixed }) => (
  <Card className={`funky-card ${fixed ? "fixed" : ""}`}>
    {image && (
      <div className="image">
        <LazyLoadImage alt="" src={image} />
      </div>
    )}
    {content && <div className="funky-content">{content}</div>}
    {foot && (
      <div className="funky-foot">
        {foot}
        {/* <div className="funk" style={{ background: 'url("/images/misc/angle.png")' }} />
        <div className="content">{foot}</div> */}
      </div>
    )}
  </Card>
);

export default FunkyCard;
